/* eslint-disable */
<template>
  <div class="live-page">
    <div class="live-select">
      <div class="live-select-label">切换会议:</div>
      <van-dropdown-menu active-color="#aa341b" class="live-select-dropdown">
        <van-dropdown-item
          v-model="selectedConference"
          :options="conferenceOptions"
          get-container="body"
          @change="onConferenceChange"
        />
      </van-dropdown-menu>
    </div>
    <!-- 主要内容区域 -->
    <div v-if="conference" class="content">
      <!-- 封面图 -->
      <div v-if="conference.banner_url" class="banner">
        <img :src="conference.banner_url" alt="Banner" />
        <!-- <div class="status-tag">未开始</div> -->
      </div>
      <div class="steps">
        <van-steps v-if="conference.status === 'upcoming' || conference.status === 'warmup' || conference.status === 'reminder'" :active="activeStep" active-icon="flag-o" active-color="#aa341b">
          <van-step><span class="step" @click="previewLive()">邀请<Icon class="preview-icon" name="browsing-history" /></span></van-step>
          <van-step><span class="step" @click="previewLive('warmup')">预热<Icon class="preview-icon" name="browsing-history" /></span></van-step>
          <van-step><span class="step" @click="previewLive('reminder')">提醒<Icon class="preview-icon" name="browsing-history" /></span></van-step>
          <van-step><span class="step" @click="previewLive('highlight')">精粹<Icon class="preview-icon" name="browsing-history" /></span></van-step>
        </van-steps>
        <van-steps v-if="conference.status === 'finish' || conference.status === 'highlight'" :active="activeStepFinish" active-icon="flag-o" active-color="#aa341b">
          <van-step><span>结束</span></van-step>
          <van-step><span class="step" @click="previewLive('highlight')">精粹<Icon class="preview-icon" name="browsing-history" /></span></van-step>
        </van-steps>
      </div>
      <!-- 直播信息 -->
      <div class="live-info">
        <div>
          <h2>{{ conference.conference_name }}</h2>
          <p class="time">{{ formattedTime }}</p>
        </div>
        <!-- <span class="buttons">
          <img
            src="@/assets/lundbeck/NBA/preview.png"
            alt=""
            style="margin-left: 4px"
            @click="previewLive()"
          />
        </span> -->
      </div>
      <div v-if="false" class="highlight-title">
        <Divider style="margin: 0 0 20px 0" />
        快捷转发
      </div>

      <van-search
        v-model="search_key"
        shape="round"
        placeholder="请输入医生搜索"
      />
      <cube-tab-bar
        v-model="selectedLabelDefault"
        :data="tabs"
        class="top-tab box"
        style="z-index: 5"
        @click="clickHandler"
      >
        <cube-tab v-for="item in tabs" :key="item.label" :label="item.label">{{
          item.text
        }}</cube-tab>
      </cube-tab-bar>
      <!-- list -->
      <div style="padding: 0 5px;">
        <van-list
          v-model="listLoading"
          :finished="listFinished"
          :immediate-check="false"
          @load="onLoad"
        >
          <livePhysicianItem
            v-for="(item, index) in list"
            :key="index"
            :status="conference.status"
            :onsite-content="onsiteContent"
            :live-content="liveContent"
            :live-warmup-content="liveWarmupContent"
            :live-reminder-content="liveReminderContent"
            :live-highlight-content="liveHighlightContent"
            :item="item"
            @clickItem="livePhysicianItemClick"
          />
          <van-empty v-if="!listLoading && !list.length" image="search" image-size="100" description="无匹配医生" />
        </van-list>
        <div v-if="selectedLabelDefault === '1' && conference.status !== 'highlight' && conference.status !== 'finish'" class="other-doctor">
          <span @click="sendToOtherDoctor">邀请其他医生</span>
        </div>
        <div style="height: 80px;"></div>
      </div>
    </div>
    <transition name="slide">
      <swipeDialog
        v-if="livePreview"
        backtxt="返回"
        :title="'预览'"
        class="slide-in"
        @closeFn="closePreviewFn"
      >
        <div>
          <div v-if="htmlContent" class="html-content" v-html="htmlContent"></div>
          <!-- <img v-if="conference?.poster_url" :src="conference?.poster_url" class="poster" /> -->
        </div>
      </swipeDialog>
    </transition>
    <DoctorListSelect
      v-if="showDoctorSelect"
      :multiple-mode="false"
      :default-selected-list="doctors"
      @close="showDoctorSelect = false"
      @select="handleSelectDoctor"
    />
  </div>
</template>

<script>
import { Divider, Search, List, DropdownMenu, DropdownItem, Empty, Steps, Step, Icon } from 'vant';
import swipeDialog from '@/views/layout/swipeDialog';
import { getTargetHCP, getRecentConference, getContent } from '@/api/live';
import livePhysicianItem from './components/livePhysicianItem.vue';
import {getLocalStorage} from '@/utils';
import DoctorListSelect from '@/components/DoctorListSelect.vue';
import {wecomSDK} from '@/utils/wecom';
import {selectRecommendedWording} from '@/utils/recommendedWording';

// import Nodata from '@/components/Nodata';
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1);
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
};
const formatTime = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}年${month}月${day}日${hours}:${minutes}`;
};

export default {
  name: 'LivePage',
  components: {
    Divider,
    swipeDialog,
    'van-search': Search,
    'van-list': List,
    'van-empty': Empty,
    'van-steps': Steps,
    'van-step': Step,
    Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    // Nodata,
    livePhysicianItem,
    DoctorListSelect,
  },
  data() {
    return {
      search_key: '',
      selectedLabelDefault: '1',
      tabs: [
        {
          text: '推荐邀请',
          label: '1',
        },
        // {
        //   text: '已邀请现场参会',
        //   label: '2',
        // },
        {
          text: '已邀请',
          label: '3',
        },
      ],
      conferenceOptions: [],
      conferenceData: [],
      conference: null,
      selectedConference: null,
      liveContent: null,
      liveWarmupContent: null,
      liveReminderContent: null,
      liveHighlightContent: null,
      onsiteContent: null,
      list: [],
      page_index: 1,
      page_size: 10,
      listLoading: false,
      listFinished: false,
      live_is_invited: false,
      onsite_is_invited: false,
      livePreview: false,
      htmlContent: null,
      showDoctorSelect: false,
      doctors: [],
      forwardContent: {
        id: '',
        title: '',
        physicianId: '',
        description: '',
        wxLogo: '',
        recommendedWording: '',
      },
    };
  },
  computed: {
    formattedTime() {
      if (!this.conference) return '';
      const startTime = new Date(this.conference.start_time);
      const endTime = new Date(this.conference.end_time);

      const startFormatted = formatTime(startTime);
      const endFormatted = formatTime(endTime);

      return `${startFormatted}`;
    },
    activeStep() {
      if (!this.conference) return 0;
      if (this.conference.status === 'warmup') {
        return 1;
      } else if (this.conference.status === 'reminder') {
        return 2;
      } else if (this.conference.status === 'highlight') {
        return 3;
      }
      return 0;
    },
    activeStepFinish() {
      if (!this.conference) return 0;
      if (this.conference.status === 'finish') {
        return 0;
      } else if (this.conference.status === 'highlight') {
        return 1;
      }
      return 0;
    }
  },
  watch: {
    search_key() {
      this.resetList();
      this.getList();
    },
    selectedLabelDefault(val) {
      this.resetList();
      switch (val) {
        case '1':
          this.live_is_invited = false;
          this.onsite_is_invited = false;
          this.getList();
          break;
        case '2':
          this.live_is_invited = false;
          this.onsite_is_invited = true;
          this.getList();
          break;
        case '3':
          this.live_is_invited = true;
          this.onsite_is_invited = false;
          this.getList();
          break;
        default:
          break;
      }
    },
  },
  async created() {
    const confRes = await getRecentConference();
    if (confRes && confRes.value && confRes.value.length) {
      this.conferenceData = confRes.value;
      this.conferenceData.sort((a, b) => {
        const statusPriority = {
          upcoming: 1,
          warmup: 1,
          reminder: 1,
          finish: 3,
          highlight: 2,
        };

        const priorityA = statusPriority[a.status] || 4;
        const priorityB = statusPriority[b.status] || 4;

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        return new Date(b.start_time) - new Date(a.start_time);
      });
      this.conferenceOptions = this.conferenceData.map((item) => {
        const statusNames = {
          upcoming: '邀请中',
          warmup: '预热中',
          reminder: '提醒中',
          finish: '已结束',
          highlight: '精粹回顾',
        };
        return {
          text: formatDate(new Date(item.start_time)) + ' - ' + item.conference_name + (statusNames[item.status] ? ' (' + statusNames[item.status] + ')' : ''),
          value: item.conference_id,
        };
      });
      this.selectedConference = this.conferenceOptions[0].value;
      this.conference = this.conferenceData[0];
      if (this.conference.onsite_content_id) {
        this.onsiteContent = await getContent(this.conference.onsite_content_id);
      }
      if (this.conference.live_content_id) {
        this.liveContent = await getContent(this.conference.live_content_id);
      }
      if (this.conference.live_warmup_content_id) {
        this.liveWarmupContent = await getContent(this.conference.live_warmup_content_id);
      }
      if (this.conference.live_reminder_content_id) {
        this.liveReminderContent = await getContent(this.conference.live_reminder_content_id);
      }
      if (this.conference.live_highlight_content_id) {
        this.liveHighlightContent = await getContent(this.conference.live_highlight_content_id);
      }
      this.getList();
    }
  },
  methods: {
    async getList() {
      this.listLoading = true;
      const products = this.conference.conference__conference_products
        .map(product => product.product_id)
        .join(',');
      const res = await getTargetHCP({
        conference_id: this.conference.conference_id,
        page_index: this.page_index,
        page_size: this.page_size,
        search_key: this.search_key,
        live_is_invited: this.live_is_invited,
        onsite_is_invited: this.onsite_is_invited,
        product_ids: this.live_is_invited ? null : products,
        scope: this.live_is_invited ? null : this.conference.scope,
      });
      // console.log('res----->', res);
      this.listLoading = false;
      if (res.data.length) {
        this.list = [...this.list, ...res.data];
      } else {
        this.listFinished = true;
      }
    },
    onLoad() {
      if (!this.loading) {
        this.page_index++;
        this.listLoading = true;
        this.getList();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.push('/');
    },
    clickHandler() {},
    resetList() {
      this.page_index = 1;
      this.list = [];
      this.listFinished = false;
    },
    previewLive(step) {
      this.htmlContent = this.liveContent.content_body;
      if (step === 'warmup' && this.liveWarmupContent) {
        this.htmlContent = this.liveWarmupContent.content_body;
      } else if (step === 'reminder' && this.liveReminderContent) {
        this.htmlContent = this.liveReminderContent.content_body;
      } else if (step === 'highlight' && this.liveHighlightContent) {
        this.htmlContent = this.liveHighlightContent.content_body;
      }
      this.livePreview = true;
      this.$store.dispatch('setDialogStatus', true);
    },
    closePreviewFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.livePreview = false;
    },
    onConferenceChange(val) {
      this.conference = null;
      setTimeout(async () => {
        this.conference = this.conferenceData.find((conf) => conf.conference_id === val);
        this.onsiteContent = null;
        this.liveContent = null;
        this.liveWarmupContent = null;
        this.liveReminderContent = null;
        this.liveHighlightContent = null;
        if (this.conference.onsite_content_id) {
          this.onsiteContent = await getContent(this.conference.onsite_content_id);
        }
        if (this.conference.live_content_id) {
          this.liveContent = await getContent(this.conference.live_content_id);
        }
        if (this.conference.live_warmup_content_id) {
          this.liveWarmupContent = await getContent(this.conference.live_warmup_content_id);
        }
        if (this.conference.live_reminder_content_id) {
          this.liveReminderContent = await getContent(this.conference.live_reminder_content_id);
        }
        if (this.conference.live_highlight_content_id) {
          this.liveHighlightContent = await getContent(this.conference.live_highlight_content_id);
        }
        this.resetList();
        this.getList();
      }, 10);
    },
    sendToOtherDoctor() {
      this.forwardContent.id = this.liveContent.content_id;
      this.forwardContent.title = this.liveContent.content_name;
      this.forwardContent.description = this.liveContent.description;
      this.forwardContent.wxLogo = this.liveContent.wx_logo;
      this.forwardContent.recommendedWording = this.liveContent.recommended_wording;
      this.showDoctorSelect = true;
    },
    handleSelectDoctor(doctors) {
      this.forwardContent.physicianId = doctors[0].physician_id;
      this.doctors = doctors;
      this.showDoctorSelect = false;
      this.forwardWechat();
    },
    livePhysicianItemClick(item, content) {
      console.log('livePhysicianItemClick', item, content);
      this.forwardContent.id = content.content_id;
      this.forwardContent.title = content.content_name;
      this.forwardContent.description = content.description;
      this.forwardContent.wxLogo = content.wx_logo;
      this.forwardContent.recommendedWording = content.recommended_wording;
      this.forwardContent.physicianId = item.physician_id;
      this.forwardWechat();
    },
    async forwardWechat() {
      console.log('forward', this.forwardContent);

      const toast = this.$createToast({
        time: 10000,
        mask: false,
      });
      try {
        // 检查是否有建议话术
        if (this.forwardContent.recommendedWording) {
          try {
            const wordingToCopy = await selectRecommendedWording(this.forwardContent.recommendedWording, {
              title: '建议话术',
              confirmButtonText: '复制话术',
              cancelButtonText: '跳过',
            });

            if (wordingToCopy) {
              const success = await wecomSDK.copyToClipboard(wordingToCopy);
              if (success) {
                // this.$toast.success('复制成功');
              } else {
                this.$toast.fail('复制失败');
              }
            }
          } catch (err) {
            console.log(err);
            // 忽略 Dialog cancel 的错误，继续执行
          }
        }

        // 显示加载提示
        toast.show();

        // 执行转发
        await wecomSDK.shareWechatMessage({
          content_id: this.forwardContent.id,
          sender_user_id: getLocalStorage('user_id'),
          sender_user_name: getLocalStorage('user_name'),
          sender_territory_id: getLocalStorage('territory_id'),
          receiver_physician_id: this.forwardContent.physicianId,
          send_time: new Date(),
          title: this.forwardContent.title,
          description: this.forwardContent.description,
          wx_logo: this.forwardContent.wxLogo,
        });

        toast.hide();
      } catch (err) {
        toast.hide();
        console.error('Forward error:', err);
        this.$toast.fail('转发失败，请稍后重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.live-page {
  height: 100vh;
  background: #f2f5f9;
  display: flex;
  flex-direction: column;
}
.poster {
  display: block;
  width: 100%;
}
.header {
  height: 44px;
  background: #4477dd;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  position: relative;

  .nav-left {
    display: flex;
    gap: 15px;
  }

  .title {
    font-size: 18px;
    font-weight: 500;
  }
}

.content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 50px;

  .banner {
    position: relative;
    width: 100%;
    // height: 220px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }

    .status-tag {
      position: absolute;
      top: 10px;
      right: 10px;
      background: #4477dd;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 12px;
    }
  }

  .live-info {
    padding: 10px;
    background: white;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 16px;
      margin: 0 10px 8px 10px;
    }

    .time {
      color: #999;
      font-size: 14px;
      margin: 0 10px;
    }
    span.buttons {
      display: flex;
      justify-content: flex-end;
      width: 80px; // 根据按钮总宽度调整

      img {
        display: inline-block;
        width: 26px; // 64 x 96
        height: 39px;
      }
    }
  }
  .highlight-title {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    background: white;
  }
}

.bottom-nav {
  height: 50px;
  background: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  width: 100%;

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #666;
    gap: 4px;

    &.active {
      color: #4477dd;
    }

    .van-icon {
      font-size: 20px;
    }
  }
}

.box {
  border-top: none;
}
.profile-details ::v-deep .cube-pullup-wrapper {
  .before-trigger {
    font-size: 13px;
    padding: 15px 0;
    color: #dddddd;
  }
}
.fixed-up {
  font-size: 20px;
  padding: 8px 10px;
  border-radius: 50%;
  color: #aa341b;
  position: fixed;
  right: 20px;
  bottom: 80px;
  border: 1px solid #dddddd;
  background-color: #ffffff;
}
.cube-tab-bar {
  background: #fff;
  &.top-tab-kol {
    top: 2.3rem !important;
  }
  &.top-tab {
    // background: #aa341b;
    // position: fixed;
    padding: 10px 0 0 0;
    // z-index: 99;
    width: 100%;
    // top: 20px;
    transition: transform 0.3s;
    border-bottom: none !important; //1px solid #fff;
    z-index: 1;
    &.shrinked {
      transform: translateY(-58px);
      // top: 48px;
    }

    .cube-tab {
      // color: #eee;
      padding: 10px 0 6px 0;

      &.cube-tab_active {
        margin: 0 5px;
        background: #aa341b;
        color: #fff;
        border-radius: 10px 10px 0 0;
      }
    }

    .cube-tab-bar-slider {
      background-color: #fff;
      bottom: -2px;
    }
  }
  padding: 5px 0;
  width: 100%;
  font-size: 14px;
  border-bottom: 1px solid #e4e4e4;

  .cube-tab {
    color: #999;

    &.cube-tab_active {
      color: #000;
    }
  }
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}
.live-select {
  //   margin-top: 20px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 0 20px 0 10px;
  .live-select-label {
    font-size: 11px;
    color: #999;
    line-height: 40px;
    white-space: nowrap;
  }
  .live-select-dropdown {
    width: calc(100vw - 80px);

  }
  // justify-content: space-between;
  ::v-deep .van-dropdown-menu__bar {
    box-shadow: none;
    height: 40px;
  }
}
.steps {
  padding: 0 15px; background-color: white; display: block; text-align: left;
  ::v-deep .van-step__title {
    font-size: 16px;
  }
  .step {
    margin-right: -10px;
  }
  .preview-icon {
    font-size: 16px;
    margin-left: 1px;
  }
}
.html-content {
  padding: 0;
  max-width: 100%;
  overflow: auto;
  ::v-deep img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.other-doctor {
  margin-top: 30px;
  position: fixed;
  width: 100%;
  height: 75px;
  height: calc(env(safe-area-inset-bottom, 0px) + 45px);
  background-color: #f2f5f9;
  text-align: center;
  bottom: 50px;
  span {
    cursor: pointer;
    padding: 4px 16px;
    border-radius: 20px;
    border: 1px solid #aa341b;
    background-color: #fff;
    color: #aa341b;
    font-size: 12px;
  }
}
</style>
<style lang="scss">
.van-dropdown-item__content .van-cell__title,
.van-dropdown-item__content .van-cell__value {
  flex: auto !important;
}
</style>
<style lang="scss">
.recommended-wording-dialog {
  .van-dialog__message {
    padding: 20px;
    white-space: pre-wrap;
    background-color: #f8f8f8;
    border-radius: 4px;
    margin: 10px 20px;
    font-size: 14px;
    line-height: 1.5;
    user-select: all;
  }

  .van-dialog__footer {
    padding: 8px 16px 16px;
  }

  .van-button--primary {
    background-color: #aa341b;
    border-color: #aa341b;
  }
}
</style>
